import LbTable from './src/table';

/* istanbul ignore next */
LbTable.install = function(Vue) {
  Vue.component(LbTable.name, LbTable);
};

export default LbTable;
